import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if @model.canLoadMore}}
  {{hide-application-footer}}
{{/if}}

{{#if this.redirectedReason}}
  <div class="alert alert-info">{{this.redirectedReason}}</div>
{{/if}}

{{#if @model.sharedDrafts}}
  {{#if this.currentUser.use_glimmer_topic_list}}
    <TopicList::List
      @listTitle="shared_drafts.title"
      @top={{this.top}}
      @hideCategory="true"
      @category={{@category}}
      @topics={{@model.sharedDrafts}}
      @discoveryList={{true}}
      class="shared-drafts"
    />
  {{else}}
    <TopicList
      @listTitle="shared_drafts.title"
      @top={{this.top}}
      @hideCategory="true"
      @category={{@category}}
      @topics={{@model.sharedDrafts}}
      @discoveryList={{true}}
      class="shared-drafts"
    />
  {{/if}}
{{/if}}

<DiscoveryTopicsList
  @model={{@model}}
  @incomingCount={{this.topicTrackingState.incomingCount}}
  @bulkSelectHelper={{@bulkSelectHelper}}
>
  {{#if this.top}}
    <div class="top-lists">
      <PeriodChooser
        @period={{@period}}
        @action={{@changePeriod}}
        @fullDay={{false}}
      />
    </div>
  {{else}}
    {{#if (or this.topicTrackingState.hasIncoming @model.loadingBefore)}}
      <div class="show-more {{if this.hasTopics 'has-topics'}}">
        <a
          tabindex="0"
          href
          {{on "click" this.showInserted}}
          class="alert alert-info clickable
            {{if @model.loadingBefore 'loading'}}"
        >
          <CountI18n
            @key="topic_count_"
            @suffix={{this.topicTrackingState.filter}}
            @count={{or
              @model.loadingBefore
              this.topicTrackingState.incomingCount
            }}
          />
          {{#if @model.loadingBefore}}
            {{loading-spinner size="small"}}
          {{/if}}
        </a>
      </div>
    {{/if}}
  {{/if}}

  {{#if this.renderNewListHeaderControls}}
    <NewListHeaderControlsWrapper
      @current={{@model.params.subset}}
      @newRepliesCount={{this.newRepliesCount}}
      @newTopicsCount={{this.newTopicsCount}}
      @changeNewListSubset={{@changeNewListSubset}}
    />
  {{/if}}

  <span>
    <PluginOutlet
      @name="before-topic-list"
      @connectorTagName="div"
      @outletArgs={{hash category=@category tag=@tag}}
    />
  </span>

  {{#if this.hasTopics}}
    {{#if this.currentUser.use_glimmer_topic_list}}
      <TopicList::List
        @highlightLastVisited={{true}}
        @top={{this.top}}
        @hot={{this.hot}}
        @showTopicPostBadges={{this.showTopicPostBadges}}
        @showPosters={{true}}
        @canBulkSelect={{@canBulkSelect}}
        @bulkSelectHelper={{@bulkSelectHelper}}
        @changeSort={{@changeSort}}
        @hideCategory={{@model.hideCategory}}
        @order={{this.order}}
        @ascending={{this.ascending}}
        @expandGloballyPinned={{this.expandGloballyPinned}}
        @expandAllPinned={{this.expandAllPinned}}
        @category={{@category}}
        @topics={{@model.topics}}
        @discoveryList={{true}}
        @focusLastVisitedTopic={{true}}
        @showTopicsAndRepliesToggle={{this.showTopicsAndRepliesToggle}}
        @newListSubset={{@model.params.subset}}
        @changeNewListSubset={{@changeNewListSubset}}
        @newRepliesCount={{this.newRepliesCount}}
        @newTopicsCount={{this.newTopicsCount}}
      />
    {{else}}
      <TopicList
        @highlightLastVisited={{true}}
        @top={{this.top}}
        @hot={{this.hot}}
        @showTopicPostBadges={{this.showTopicPostBadges}}
        @showPosters={{true}}
        @canBulkSelect={{@canBulkSelect}}
        @bulkSelectHelper={{@bulkSelectHelper}}
        @changeSort={{@changeSort}}
        @hideCategory={{@model.hideCategory}}
        @order={{this.order}}
        @ascending={{this.ascending}}
        @expandGloballyPinned={{this.expandGloballyPinned}}
        @expandAllPinned={{this.expandAllPinned}}
        @category={{@category}}
        @topics={{@model.topics}}
        @discoveryList={{true}}
        @focusLastVisitedTopic={{true}}
        @showTopicsAndRepliesToggle={{this.showTopicsAndRepliesToggle}}
        @newListSubset={{@model.params.subset}}
        @changeNewListSubset={{@changeNewListSubset}}
        @newRepliesCount={{this.newRepliesCount}}
        @newTopicsCount={{this.newTopicsCount}}
      />
    {{/if}}
  {{/if}}

  <span>
    <PluginOutlet
      @name="after-topic-list"
      @connectorTagName="div"
      @outletArgs={{hash category=@category tag=@tag}}
    />
  </span>
</DiscoveryTopicsList>

<footer class="topic-list-bottom">
  <ConditionalLoadingSpinner @condition={{@model.loadingMore}} />
  {{#if this.allLoaded}}
    <PluginOutlet
      @name="topic-list-bottom"
      @outletArgs={{hash
        category=@category
        tag=@tag
        allLoaded=this.allLoaded
        model=@model
      }}
    >
      <TopicDismissButtons
        @position="bottom"
        @selectedTopics={{@bulkSelectHelper.selected}}
        @model={{@model}}
        @showResetNew={{@showResetNew}}
        @showDismissRead={{@showDismissRead}}
        @resetNew={{@resetNew}}
        @dismissRead={{@dismissRead}}
      />

      <FooterMessage
        @education={{this.footerEducation}}
        @message={{this.footerMessage}}
      >
        {{#if @tag}}
          {{html-safe
            (i18n "topic.browse_all_tags_or_latest" basePath=(base-path))
          }}
        {{else if this.latest}}
          {{#if @category.canCreateTopic}}
            <DiscourseLinkedText
              @action={{fn
                this.composer.openNewTopic
                (hash category=@category preferDraft=true)
              }}
              @text="topic.suggest_create_topic"
            />
          {{/if}}
        {{else if this.top}}
          {{html-safe
            (i18n
              "topic.browse_all_categories_latest_or_top" basePath=(base-path)
            )
          }}
          <TopPeriodButtons @period={{@period}} @action={{@changePeriod}} />
        {{else}}
          {{html-safe
            (i18n "topic.browse_all_categories_latest" basePath=(base-path))
          }}
        {{/if}}
      </FooterMessage>
    </PluginOutlet>
  {{/if}}
</footer>
*/
{
  "id": "iUJkiFD8",
  "block": "[[[41,[30,1,[\"canLoadMore\"]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"redirectedReason\"]],[[[1,\"  \"],[10,0],[14,0,\"alert alert-info\"],[12],[1,[30,0,[\"redirectedReason\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"sharedDrafts\"]],[[[41,[30,0,[\"currentUser\",\"use_glimmer_topic_list\"]],[[[1,\"    \"],[8,[39,2],[[24,0,\"shared-drafts\"]],[[\"@listTitle\",\"@top\",\"@hideCategory\",\"@category\",\"@topics\",\"@discoveryList\"],[\"shared_drafts.title\",[30,0,[\"top\"]],\"true\",[30,2],[30,1,[\"sharedDrafts\"]],true]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,3],[[24,0,\"shared-drafts\"]],[[\"@listTitle\",\"@top\",\"@hideCategory\",\"@category\",\"@topics\",\"@discoveryList\"],[\"shared_drafts.title\",[30,0,[\"top\"]],\"true\",[30,2],[30,1,[\"sharedDrafts\"]],true]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[8,[39,4],null,[[\"@model\",\"@incomingCount\",\"@bulkSelectHelper\"],[[30,1],[30,0,[\"topicTrackingState\",\"incomingCount\"]],[30,3]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"top\"]],[[[1,\"    \"],[10,0],[14,0,\"top-lists\"],[12],[1,\"\\n      \"],[8,[39,5],null,[[\"@period\",\"@action\",\"@fullDay\"],[[30,4],[30,5],false]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,0,[\"topicTrackingState\",\"hasIncoming\"]],[30,1,[\"loadingBefore\"]]],null],[[[1,\"      \"],[10,0],[15,0,[29,[\"show-more \",[52,[30,0,[\"hasTopics\"]],\"has-topics\"]]]],[12],[1,\"\\n        \"],[11,3],[24,\"tabindex\",\"0\"],[24,6,\"\"],[16,0,[29,[\"alert alert-info clickable\\n            \",[52,[30,1,[\"loadingBefore\"]],\"loading\"]]]],[4,[38,7],[\"click\",[30,0,[\"showInserted\"]]],null],[12],[1,\"\\n          \"],[8,[39,8],null,[[\"@key\",\"@suffix\",\"@count\"],[\"topic_count_\",[30,0,[\"topicTrackingState\",\"filter\"]],[28,[37,6],[[30,1,[\"loadingBefore\"]],[30,0,[\"topicTrackingState\",\"incomingCount\"]]],null]]],null],[1,\"\\n\"],[41,[30,1,[\"loadingBefore\"]],[[[1,\"            \"],[1,[28,[35,9],null,[[\"size\"],[\"small\"]]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n\"],[41,[30,0,[\"renderNewListHeaderControls\"]],[[[1,\"    \"],[8,[39,10],null,[[\"@current\",\"@newRepliesCount\",\"@newTopicsCount\",\"@changeNewListSubset\"],[[30,1,[\"params\",\"subset\"]],[30,0,[\"newRepliesCount\"]],[30,0,[\"newTopicsCount\"]],[30,6]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,1],[12],[1,\"\\n    \"],[8,[39,11],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"before-topic-list\",\"div\",[28,[37,12],null,[[\"category\",\"tag\"],[[30,2],[30,7]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"hasTopics\"]],[[[41,[30,0,[\"currentUser\",\"use_glimmer_topic_list\"]],[[[1,\"      \"],[8,[39,2],null,[[\"@highlightLastVisited\",\"@top\",\"@hot\",\"@showTopicPostBadges\",\"@showPosters\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@changeSort\",\"@hideCategory\",\"@order\",\"@ascending\",\"@expandGloballyPinned\",\"@expandAllPinned\",\"@category\",\"@topics\",\"@discoveryList\",\"@focusLastVisitedTopic\",\"@showTopicsAndRepliesToggle\",\"@newListSubset\",\"@changeNewListSubset\",\"@newRepliesCount\",\"@newTopicsCount\"],[true,[30,0,[\"top\"]],[30,0,[\"hot\"]],[30,0,[\"showTopicPostBadges\"]],true,[30,8],[30,3],[30,9],[30,1,[\"hideCategory\"]],[30,0,[\"order\"]],[30,0,[\"ascending\"]],[30,0,[\"expandGloballyPinned\"]],[30,0,[\"expandAllPinned\"]],[30,2],[30,1,[\"topics\"]],true,true,[30,0,[\"showTopicsAndRepliesToggle\"]],[30,1,[\"params\",\"subset\"]],[30,6],[30,0,[\"newRepliesCount\"]],[30,0,[\"newTopicsCount\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,3],null,[[\"@highlightLastVisited\",\"@top\",\"@hot\",\"@showTopicPostBadges\",\"@showPosters\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@changeSort\",\"@hideCategory\",\"@order\",\"@ascending\",\"@expandGloballyPinned\",\"@expandAllPinned\",\"@category\",\"@topics\",\"@discoveryList\",\"@focusLastVisitedTopic\",\"@showTopicsAndRepliesToggle\",\"@newListSubset\",\"@changeNewListSubset\",\"@newRepliesCount\",\"@newTopicsCount\"],[true,[30,0,[\"top\"]],[30,0,[\"hot\"]],[30,0,[\"showTopicPostBadges\"]],true,[30,8],[30,3],[30,9],[30,1,[\"hideCategory\"]],[30,0,[\"order\"]],[30,0,[\"ascending\"]],[30,0,[\"expandGloballyPinned\"]],[30,0,[\"expandAllPinned\"]],[30,2],[30,1,[\"topics\"]],true,true,[30,0,[\"showTopicsAndRepliesToggle\"]],[30,1,[\"params\",\"subset\"]],[30,6],[30,0,[\"newRepliesCount\"]],[30,0,[\"newTopicsCount\"]]]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n  \"],[10,1],[12],[1,\"\\n    \"],[8,[39,11],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"after-topic-list\",\"div\",[28,[37,12],null,[[\"category\",\"tag\"],[[30,2],[30,7]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[10,\"footer\"],[14,0,\"topic-list-bottom\"],[12],[1,\"\\n  \"],[8,[39,13],null,[[\"@condition\"],[[30,1,[\"loadingMore\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"allLoaded\"]],[[[1,\"    \"],[8,[39,11],null,[[\"@name\",\"@outletArgs\"],[\"topic-list-bottom\",[28,[37,12],null,[[\"category\",\"tag\",\"allLoaded\",\"model\"],[[30,2],[30,7],[30,0,[\"allLoaded\"]],[30,1]]]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,14],null,[[\"@position\",\"@selectedTopics\",\"@model\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],[\"bottom\",[30,3,[\"selected\"]],[30,1],[30,10],[30,11],[30,12],[30,13]]],null],[1,\"\\n\\n      \"],[8,[39,15],null,[[\"@education\",\"@message\"],[[30,0,[\"footerEducation\"]],[30,0,[\"footerMessage\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,7],[[[1,\"          \"],[1,[28,[35,16],[[28,[37,17],[\"topic.browse_all_tags_or_latest\"],[[\"basePath\"],[[28,[37,18],null,null]]]]],null]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"latest\"]],[[[41,[30,2,[\"canCreateTopic\"]],[[[1,\"            \"],[8,[39,19],null,[[\"@action\",\"@text\"],[[28,[37,20],[[30,0,[\"composer\",\"openNewTopic\"]],[28,[37,12],null,[[\"category\",\"preferDraft\"],[[30,2],true]]]],null],\"topic.suggest_create_topic\"]],null],[1,\"\\n\"]],[]],null]],[]],[[[41,[30,0,[\"top\"]],[[[1,\"          \"],[1,[28,[35,16],[[28,[37,17],[\"topic.browse_all_categories_latest_or_top\"],[[\"basePath\"],[[28,[37,18],null,null]]]]],null]],[1,\"\\n          \"],[8,[39,21],null,[[\"@period\",\"@action\"],[[30,4],[30,5]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,16],[[28,[37,17],[\"topic.browse_all_categories_latest\"],[[\"basePath\"],[[28,[37,18],null,null]]]]],null]],[1,\"\\n        \"]],[]]]],[]]]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"@model\",\"@category\",\"@bulkSelectHelper\",\"@period\",\"@changePeriod\",\"@changeNewListSubset\",\"@tag\",\"@canBulkSelect\",\"@changeSort\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],false,[\"if\",\"hide-application-footer\",\"topic-list/list\",\"topic-list\",\"discovery-topics-list\",\"period-chooser\",\"or\",\"on\",\"count-i18n\",\"loading-spinner\",\"new-list-header-controls-wrapper\",\"plugin-outlet\",\"hash\",\"conditional-loading-spinner\",\"topic-dismiss-buttons\",\"footer-message\",\"html-safe\",\"i18n\",\"base-path\",\"discourse-linked-text\",\"fn\",\"top-period-buttons\"]]",
  "moduleName": "discourse/components/discovery/topics.hbs",
  "isStrictMode": false
});